export default __webpack_public_path__ + "static/media/okey.6b4090ec.svg";